import React, { useCallback, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
const useStyles = makeStyles()(theme => {
    return {
        paddingContainer: {
            padding: '0px 16px',
        },
        container: {
            display: 'flex',
            padding: '2px',
            background: 'rgba(28, 28, 28, 1)',
            borderRadius: '8px',
            '&.is-mobile': {
                background: 'rgba(23, 23, 23, 1)',
            }
        },
        tab: {
            fontFamily: 'Lato SemiBold',
            fontWeight: 'normal',
            fontSize: '13px',
            lineHeight: '20px',
            color: 'rgba(255, 255, 255, 0.5)',
            flex: 1,
            padding: '2px 20px',
            background: 'rgba(28, 28, 28, 1)',
            border: 0,
            appearance: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 0,
            outline: 'none',
            userSelect: 'none',
            '-webkit-tap-highlight-color': 'transparent',
            '&:hover': {
                color: 'rgba(255, 255, 255, 1)',
            },
            '&.selected': {
                color: 'rgba(255, 255, 255, 0.75)',
                background: 'rgba(33, 33, 33, 1)',
                borderRadius: '6px',
                cursor: 'default',
            },
            '&:disabled': {
                color: theme.palette.text03,
                borderColor: theme.palette.ui05
            },
            '&.is-mobile': {
                background: 'rgba(23, 23, 23, 1)',
                color: 'rgba(255, 255, 255, 0.75)',
                padding: '6px 8px',
                '&.selected': {
                    color: 'rgba(255, 255, 255, 0.75)',
                    background: 'rgba(33, 33, 33, 1)',
                    borderRadius: '7px',
                    cursor: 'default',
                },
            }
        },
        badge: {
            marginTop: '2px',
            fontFamily: 'Inter Semibold',
            fontWeight: 'normal',
            fontSize: '9px',
            lineHeight: '14px',
            color: 'rgba(255, 255, 255, 0.9)',
            padding: '0 4px',
            borderRadius: '20px',
            backgroundColor: 'rgba(255, 79, 71, 1)',
            marginLeft: '4px',
            minWidth: '6px',
        }
    };
});
const Tabs = ({ accessibilityLabel, className, onChange, selected, tabs }) => {
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const onClick = useCallback(id => () => {
        onChange(id);
    }, []);
    const onKeyDown = useCallback((index) => (event) => {
        let newIndex = null;
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            newIndex = index === 0 ? tabs.length - 1 : index - 1;
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            newIndex = index === tabs.length - 1 ? 0 : index + 1;
        }
        if (newIndex !== null) {
            onChange(tabs[newIndex].id);
        }
    }, [tabs]);
    useEffect(() => {
        // this test is needed to make sure the effect is triggered because of user actually changing tab
        if (document.activeElement?.getAttribute('role') === 'tab') {
            document.querySelector(`#${selected}`)?.focus();
        }
    }, [selected]);
    return (React.createElement("div", { className: classes.paddingContainer },
        React.createElement("div", { "aria-label": accessibilityLabel, className: cx(classes.container, className, isMobile && 'is-mobile'), role: 'tablist' }, tabs.map((tab, index) => (React.createElement("button", { "aria-controls": tab.controlsId, "aria-label": tab.accessibilityLabel, "aria-selected": selected === tab.id, className: cx(classes.tab, selected === tab.id && 'selected', isMobile && 'is-mobile'), disabled: tab.disabled, id: tab.id, key: tab.id, onClick: onClick(tab.id), onKeyDown: onKeyDown(index), role: 'tab', tabIndex: selected === tab.id ? undefined : -1 },
            tab.label,
            tab.countBadge && React.createElement("span", { className: classes.badge }, tab.countBadge > 9 ? '9+' : tab.countBadge)))))));
};
export default Tabs;
